var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.869,
    height: 43.34,
    viewBox: "0 0 39.869 43.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.22,374.593a5.485,5.485,0,0,0-7.742,0h0l-7.655,7.658a4.2,4.2,0,0,1-5.919,0,4.2,4.2,0,0,1,0-5.925.644.644,0,0,0-.912-.911,5.476,5.476,0,0,0,7.742,7.747l7.655-7.659h0a4.2,4.2,0,0,1,5.919,0,4.192,4.192,0,0,1,0,5.923l-2.23,2.234a.644.644,0,0,0,.912.91l2.23-2.233A5.482,5.482,0,0,0,76.22,374.593Z",
    transform: "translate(-49.691 -341.42)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.824 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.315,27.74a.644.644,0,0,1-.644-.644V18.6a.644.644,0,0,1,.443-.612L74.285,15.3a.644.644,0,0,1,.846.612v7.262a.644.644,0,0,1-1.289,0V16.806L66.96,19.071V27.1A.644.644,0,0,1,66.315,27.74Z",
    transform: "translate(-65.671 -15.271)",
    fill: "#66c08c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.498 27.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.187,331.678l.858-.858-2.009-4.071-4.093-2.034-.858.858a4.316,4.316,0,1,0,6.1,6.105Z",
    transform: "translate(-61.827 -324.714)",
    fill: "#0593ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.614 14.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.929,187.337l13.262-13.269L104,169.894l-3.91-1.931L86.827,181.232Z",
    transform: "translate(-86.827 -167.963)",
    fill: "#176eb5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.63,12.674q-.178.272-.379.532c-.131.168-.269.333-.415.493-.084.094-.173.186-.263.277l-1.447,1.448c-.09.09-.183.179-.277.263-.16.146-.325.284-.492.415s-.351.261-.532.38a8.24,8.24,0,0,1-6.669,1.039l-3.971-1.735-1.736-3.973a8.245,8.245,0,0,1,1.04-6.672c.118-.181.245-.359.379-.533s.268-.332.414-.492c.084-.094.173-.186.263-.277L277,2.39c.089-.09.181-.178.274-.264q.24-.219.495-.415t.53-.379A8.189,8.189,0,0,1,289.63,12.674Z",
    transform: "translate(-273.158 0)",
    fill: "#176eb5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.235 11.273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.071,142.031a1.85,1.85,0,0,0,0-2.607l-5.706-5.709a1.845,1.845,0,0,0-2.6,0l-.517.517a1.115,1.115,0,0,0,0,1.573l.317.317,6.1,6.105.317.317a1.114,1.114,0,0,0,1.572,0Z",
    transform: "translate(-235.921 -133.178)",
    fill: "#66c08c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.052 31.961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.075,380.068a4.327,4.327,0,0,0,6.1,0l.858-.858-1.63-1.63-.86.858a4.331,4.331,0,0,1-5.175.7A4.3,4.3,0,0,0,69.075,380.068Z",
    transform: "translate(-68.371 -377.579)",
    fill: "#2ed1e2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.681 15.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.559,192.14l.317.317a1.114,1.114,0,0,0,1.572,0l.517-.515a1.85,1.85,0,0,0,0-2.607l-1.63-1.63a1.852,1.852,0,0,1,0,2.6l-.517.517a1.114,1.114,0,0,1-1.557.014Z",
    transform: "translate(-300.261 -187.706)",
    fill: "#66c08c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.087 18.693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.928,220.828l-12.707,12.716-.553.553,1.63,1.63,13.262-13.269-1.3-1.3-.017-.014Z",
    transform: "translate(-139.668 -220.828)",
    fill: "#0593ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.755 1.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.764,33.538h0Zm1.63,1.63a8.226,8.226,0,0,0,7.2-1.419,8.12,8.12,0,0,0,.769-.678l1.447-1.448a8.14,8.14,0,0,0,.678-.769,8.192,8.192,0,0,0-1.55-11.573,8.235,8.235,0,0,1-.079,9.941,8.513,8.513,0,0,1-.68.769l-1.447,1.448a8.488,8.488,0,0,1-.769.68,8.218,8.218,0,0,1-7.2,1.416v0h0Z",
    transform: "translate(-324.764 -19.281)",
    fill: "#0593ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.265 22.395)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.856,270.986l1.73-2.082c.356-.4.332-.527-.192-.654l-2.685-.666c-.3-.075-.322-.156-.471-.4l-1.358-2.268c-.274-.459-.442-.459-.716,0l-1.358,2.268c-.149.248-.166.329-.471.4l-2.685.666c-.522.127-.548.25-.192.654l1.73,2.082a1.022,1.022,0,0,1,.188.8l-.207,2.575c-.058.536.055.6.553.4l2.363-.984a1.272,1.272,0,0,1,.875,0l2.363.984c.5.2.61.137.553-.4l-.207-2.575A1.032,1.032,0,0,1,374.856,270.986Z",
    transform: "translate(-366.22 -264.567)",
    fill: "#66c08c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.658 22.555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.319,270.563a13.936,13.936,0,0,1-2.009,5.547l1.471-.611a1.273,1.273,0,0,1,.875,0l2.363.984c.5.2.61.137.553-.4l-.207-2.575a1.032,1.032,0,0,1,.188-.8l1.73-2.085c.356-.4.332-.524-.192-.652l-2.685-.666c-.3-.075-.322-.156-.471-.4l-1.358-2.268a1.756,1.756,0,0,0-.123-.185A16.047,16.047,0,0,1,408.319,270.563Z",
    transform: "translate(-406.31 -266.451)",
    fill: "#66c08c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.036 12.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.185,151.388c-.16.146-.325.284-.492.415s-.351.261-.532.38l-2.829-2.831a.644.644,0,1,1,.912-.911l2.905,2.907C391.161,151.361,391.174,151.375,391.185,151.388Z",
    transform: "translate(-387.142 -148.252)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.719 4.114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.628,52.456a.645.645,0,0,1-.911,0l-2.829-2.831c.118-.181.245-.359.379-.533s.268-.332.414-.492a.422.422,0,0,1,.041.037l2.906,2.907A.644.644,0,0,1,292.628,52.456Z",
    transform: "translate(-288.888 -48.601)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.498 1.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.583,19.482a.645.645,0,0,1-.911,0l-2.909-2.907a.421.421,0,0,1-.037-.041q.24-.219.495-.415t.53-.379l2.831,2.831a.644.644,0,0,1,0,.911Z",
    transform: "translate(-321.727 -15.74)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.929 9.654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.258,117.067q-.178.272-.379.532c-.131.168-.269.333-.415.493-.015-.012-.028-.025-.041-.038l-2.906-2.907a.644.644,0,0,1,.912-.911Z",
    transform: "translate(-421.328 -114.047)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.983 20.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.335,248.263a.644.644,0,0,1-.456-1.1l2.906-2.907a.644.644,0,0,1,.912.911l-2.906,2.907A.643.643,0,0,1,186.335,248.263Z",
    transform: "translate(-185.69 -244.067)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.105,144.18a3.159,3.159,0,0,0,2.605-2.758c0-1.224-1.168-1.977-2.605-1.681A3.159,3.159,0,0,0,20.5,142.5C20.5,143.725,21.666,144.478,23.105,144.18Z",
    transform: "translate(-20.5 -139.676)",
    fill: "#66c08c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.24 11.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.212,142.095a2.8,2.8,0,0,1-1.243,2.15,3.3,3.3,0,0,0,3.153-2.823c0-1.224-1.168-1.977-2.605-1.681a3.534,3.534,0,0,0-1.365.611A1.817,1.817,0,0,1,37.212,142.095Z",
    transform: "translate(-35.152 -139.676)",
    fill: "#185a76",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.292 7.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.063,98.773a3.159,3.159,0,0,0,2.605-2.758c0-1.224-1.168-1.977-2.605-1.678a3.154,3.154,0,0,0-2.605,2.756C118.458,98.319,119.624,99.071,121.063,98.773Z",
    transform: "translate(-118.458 -94.271)",
    fill: "#66c08c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.535 7.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.194,96.688a2.8,2.8,0,0,1-1.24,2.15,3.3,3.3,0,0,0,3.151-2.823c0-1.224-1.168-1.977-2.605-1.678a3.555,3.555,0,0,0-1.363.608A1.816,1.816,0,0,1,135.194,96.688Z",
    transform: "translate(-133.137 -94.271)",
    fill: "#185a76",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSing);
export default __webpack_public_path__ + "static/media/sing.a80648e241278f87c09a6646e19ffdf3.svg";
export { ForwardRef as ReactComponent };